import Vue from 'vue'
import Router from 'vue-router'
import routerM from './routerM.js'
import routerPC from './routerPC.js'
Vue.use(Router)


const ISMOBILE = function () {
  let flag = navigator.userAgent.match(
    /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
  );
  return flag;
};

export default new Router({
  routes: ISMOBILE() ? routerM : routerPC,
  mode:'history'
})



// WEBPACK FOOTER //
// ./src/router/index.js